var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6484 16C28.6484 16.2652 28.5431 16.5196 28.3555 16.7071C28.168 16.8946 27.9137 17 27.6484 17H5.64844C5.38322 17 5.12887 16.8946 4.94133 16.7071C4.75379 16.5196 4.64844 16.2652 4.64844 16C4.64844 15.7348 4.75379 15.4804 4.94133 15.2929C5.12887 15.1054 5.38322 15 5.64844 15H27.6484C27.9137 15 28.168 15.1054 28.3555 15.2929C28.5431 15.4804 28.6484 15.7348 28.6484 16Z",
    fill: "currentColor"
  })));
};
export default SvgMinus;